import { render, staticRenderFns } from "./ClusterFormSubmissions.vue?vue&type=template&id=1d7c44d6&"
import script from "./ClusterFormSubmissions.vue?vue&type=script&lang=js&"
export * from "./ClusterFormSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./ClusterFormSubmissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports